import { render, staticRenderFns } from "./SalesReportGroupedByLabels.vue?vue&type=template&id=1f196f30&"
import script from "./SalesReportGroupedByLabels.vue?vue&type=script&lang=ts&"
export * from "./SalesReportGroupedByLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports